/* Accessify widget — PDP offset to clear sticky ATC pill.
 *
 * Why this exists as JS, not CSS:
 *   The widget injects `style="bottom: 3% !important"` inline via its
 *   own runtime, AFTER the page's CSS applies. Inline !important always
 *   beats stylesheet !important in the cascade. Our only path is to
 *   override the inline style directly via JS, and re-assert it whenever
 *   the widget re-mutates the style attribute.
 *
 * Legal cleared: briefs/output/design/legal-accessibility-widget-2026-05-19.md.
 * Real selector verified by DOM-inspect 2026-05-19 pm:
 *   <div id="accessify-widget-btn" class="widget-toggle" style="...">
 *
 * Behaviour:
 *   - Runs ONLY on product templates (body.template-product).
 *   - Lifts the widget to bottom: 88px on PDPs.
 *   - Uses MutationObserver on the widget's `style` attribute so that
 *     any widget-internal re-application of `bottom: 3%` gets re-overridden.
 *   - Lives behind a DOMContentLoaded listener so it doesn't block render.
 *   - Polls for up to 10 seconds for the widget to mount, since it loads async.
 */
(function () {
  'use strict';

  // FIXPACK 2026-10-13 (layout only, theme-side, the Accessify app's own settings are untouched).
  // Mobile (<= 749px), EVERY template: the launcher is parked in the bottom strip at the physical right, vertically centred on the
  // 64px sticky add-to-cart strip (bottom = 12 + (64-50)/2 + safe area). It is the same place on every page, it never floats over page
  // content or a CTA, and the cookie banner / sticky bar stand above or beside it instead of moving it.
  // Desktop: PDP only, 88px as before.
  var isProduct = document.body.classList.contains('template-product');
  var isMobile  = window.matchMedia('(max-width: 749.98px)').matches;
  if (!isProduct && !isMobile) return;

  var TARGET_BOTTOM = isMobile ? 'calc(19px + env(safe-area-inset-bottom, 0px))' : '88px';
  var expected = null;   // the browser's own serialisation of TARGET_BOTTOM, read back once: compare against THAT, never the literal (no write loop)
  var WIDGET_SELECTOR = '#accessify-widget-btn';
  var MAX_WAIT_MS = 10000;
  var POLL_INTERVAL_MS = 200;

  function applyOffset(el) {
    if (!el) return;
    el.style.setProperty('bottom', TARGET_BOTTOM, 'important');
    expected = el.style.getPropertyValue('bottom');
  }

  function watchAndReassert(el) {
    applyOffset(el);
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'style') {
          var current = el.style.getPropertyValue('bottom');
          if (current !== expected) {
            applyOffset(el);
          }
        }
      });
    });
    mo.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    var started = Date.now();
    var existing = document.querySelector(WIDGET_SELECTOR);
    if (existing) {
      watchAndReassert(existing);
      return;
    }
    // Widget mounts async — poll for it.
    var iv = setInterval(function () {
      var el = document.querySelector(WIDGET_SELECTOR);
      if (el) {
        clearInterval(iv);
        watchAndReassert(el);
      } else if (Date.now() - started > MAX_WAIT_MS) {
        clearInterval(iv);
        // Widget never mounted on this PDP — silent no-op.
      }
    }, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
